// src/components/Footer.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FaInstagram, FaFacebook, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, 
  FaCcVisa, FaCcMastercard, FaLock 
} from "react-icons/fa";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext"; // 🔥 YENİ: Ziyaretçi/Üye kontrolü için eklendi

const Footer = () => {
  const { currentUser } = useAuth(); // Sisteme giriş yapan biri var mı kontrolü
  
  const [contactInfo, setContactInfo] = useState({
    phone: "0555 555 55 55",
    email: "info@senabebe.com.tr",
    address: "Çamdibi, Bornova / İzmir\nTürkiye",
    instagram: "https://www.instagram.com/senabebecamdibi/"
  });

  useEffect(() => {
    const fetchContactSettings = async () => {
      try {
        const docRef = doc(db, "settings", "contact");
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          setContactInfo({
            phone: data.phone || "0555 555 55 55",
            email: data.email || "info@senabebe.com.tr",
            address: data.address || "Çamdibi, Bornova / İzmir\nTürkiye",
            instagram: data.instagram || "https://www.instagram.com/senabebecamdibi/"
          });
        }
      } catch (error) {
        console.error("Footer iletişim bilgileri çekilemedi:", error);
      }
    };

    fetchContactSettings();
  }, []);

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto pb-24 md:pb-0">
      
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          {/* 1. Marka & Hakkında */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <h3 className="font-extrabold text-3xl text-transparent bg-clip-text bg-gradient-to-r from-[#6A0DAD] to-purple-400">
                SenaBebe
              </h3>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              Minik kalpler için sevgiyle seçilmiş, en güvenli ve kaliteli bebek ürünleri. Bebeğinizin konforu, bizim mutluluğumuzdur.
            </p>
            
            <div className="flex items-center gap-4 pt-2">
              <a
                href={contactInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white border border-gray-200 text-[#6A0DAD] flex items-center justify-center hover:bg-[#6A0DAD] hover:text-white transition-all duration-300 shadow-sm"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
              <button
                onClick={() => alert("Facebook sayfamız yakında!")}
                className="w-10 h-10 rounded-full bg-white border border-gray-200 text-blue-600 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all duration-300 shadow-sm"
                aria-label="Facebook"
              >
                <FaFacebook size={20} />
              </button>
            </div>
          </div>

          {/* 2. Kurumsal & Yardım (GÜNCELLENDİ) */}
          <div>
            <h4 className="font-bold text-gray-900 mb-5 text-lg">Kurumsal & Yardım</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li>
                <Link to="/hakkimizda" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/iletisim" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Bize Ulaşın</Link>
              </li>
              <li>
                <Link to="/sss" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Sıkça Sorulan Sorular</Link>
              </li>
              <li>
                {/* 🔥 YENİ: Ziyaretçi ise kargo takibe, üyeyse kendi siparişlerine */}
                <Link to={currentUser ? "/my-orders" : "/kargo-takip"} className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Sipariş Takibi</Link>
              </li>
              <li>
                {/* 🔥 YENİ: Ziyaretçi ise login sayfasına, üyeyse profile */}
                <Link to={currentUser ? "/profile" : "/login"} className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Hesabım</Link>
              </li>
            </ul>
          </div>

          {/* 3. Yasal Metinler */}
          <div>
            <h4 className="font-bold text-gray-900 mb-5 text-lg">Yasal Metinler</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li>
                <Link to="/sozlesmeler?tab=kullanimKosullari" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Site Kullanım Koşulları</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=mesafeliSatis" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Mesafeli Satış Sözleşmesi</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=obf" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Ön Bilgilendirme Formu</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=kvkk" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">KVKK Aydınlatma Metni</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=gizlilikPolitikasi" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Gizlilik ve Çerez Politikası</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=iade" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">İade ve İptal Koşulları</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=teslimat" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Teslimat Politikası</Link>
              </li>
              <li>
                <Link to="/sozlesmeler?tab=uyelikSozlesmesi" className="hover:text-[#6A0DAD] hover:pl-2 transition-all duration-300 block">Üyelik Sözleşmesi</Link>
              </li>
            </ul>
          </div>

          {/* 4. İletişim Bilgileri */}
          <div>
            <h4 className="font-bold text-gray-900 mb-5 text-lg">İletişim</h4>
            <ul className="space-y-4 text-sm text-gray-600">
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-[#6A0DAD] mt-1 shrink-0" />
                <span className="whitespace-pre-wrap">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhoneAlt className="text-[#6A0DAD] shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-[#6A0DAD]">{contactInfo.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope className="text-[#6A0DAD] shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-[#6A0DAD]">{contactInfo.email}</a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          
          <div className="text-xs text-gray-500 text-center md:text-left">
            © {new Date().getFullYear()} <span className="font-bold text-gray-700">Sena Bebe</span>. Tüm hakları saklıdır.
          </div>

          <div className="flex items-center gap-4 opacity-70 grayscale hover:grayscale-0 transition-all duration-500">
            <FaCcVisa size={28} />
            <FaCcMastercard size={28} />
            <div className="flex items-center gap-1 text-[10px] border border-gray-300 rounded px-2 py-1 bg-white">
                <FaLock size={10} className="text-green-600"/>
                <span>256Bit SSL</span>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;